import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

const StyledTabs = styled((props) => 
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />)(
  ({ theme }) => ({
    minHeight: "24px",
    "& .MuiTabs-indicator": {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "transparent",
    },
    "& .MuiTabs-indicatorSpan": {
      maxWidth: "100%",
      width: "100%",
      backgroundColor: theme.palette["primary"]["60"],
    },
  })
);

const StyledTab = styled((props) => <Tab {...props} />)(
  ({ theme, typography }) => ({
    minWidth: "fit-content",
    textTransform: "none",
    fontWeight: typography ? theme.typography[typography].fontWeight : theme.typography.subhead1.fontWeight,
    fontSize: typography ? theme.typography[typography].fontSize : theme.typography.subhead1.fontSize,
    lineHeight: typography ? theme.typography[typography].lineHeight : theme.typography.subhead1.lineHeight,
    marginRight: "12px",
    padding: "12px 4px 4px 4px",
    minHeight: "12px",
    color: theme.palette["black_opacity"]["80"],
    alignItems: "self-start",
    justifyContent: "flex-start",
    "&.Mui-selected": {
      color: theme.palette["black_opacity"]["80"]
    }
  }),
);

export default function PrimaryTabs({value, handleChange, tabLabels, typography}) {
  return (
    <StyledTabs
      value={value}
      onChange={handleChange}
      aria-label="primary tabs"
    >
      {tabLabels.map((label, i) => (
        <StyledTab key={`tab-${i}`} label={label.name} disabled={label.disabled} typography={typography} />
      ))}
    </StyledTabs>
  );
}

PrimaryTabs.propTypes = {
  value: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  tabLabels: PropTypes.array.isRequired,
  typography: PropTypes.string
};